import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=7b4e3fa4&lang=less&scoped=true"

import exportComponent from "/Users/hupeng/Documents/yanzhishi/official-website-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b4e3fa4"]])

export default __exports__